import { styled } from '@kandji-inc/nectar-ui';

export const StyledLink = styled('a', {
  color: '$blue50',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
});
